module.exports = __webpack_public_path__ + "static/media/Note-Click-Bloom-Textures-Click_Boom_00042.3dd0794b.png";